<template>
  <div class="table">
    <div class="crumbs">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item> <i class="el-icon-lx-cascades"></i> 安抚礼包 </el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="container">
      <div class="app-container">
        <div style="margin-bottom: 20px">
          <div>
            <span style="font-size: 15px; margin-left: 20px">游戏名称：</span>
            <el-select v-model="listQuery.game_id" filterable placeholder="请选择" style="margin-right: 20px">
              <el-option v-for="item in gameNameOptions" :key="item.index" :label="item.name" :value="item.id"> </el-option>
            </el-select>
            <span>礼包类型：</span>
            <el-input v-model="listQuery.code_type" placeholder="" style="width: 150px; margin-right: 20px"></el-input>
            <span style="margin-left: 20px">注册时间：</span>
            <el-date-picker
              v-model="listQuery.created_at"
              type="datetimerange"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd HH:mm:ss"
              :default-time="['24:00:00']"
            ></el-date-picker>
          </div>

          <div style="float: right; margin: 30px 30px 20px 0">
            <el-button type="success" :data-clipboard-text="newGiftCode" style="margin-right: 15px" class="getGiftCode" @click.native="judgeCopy">复制</el-button>
            <el-button class="filter-item" style="margin-left: 10px" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
            <el-button class="filter-item" style="margin-left: 10px" type="success" @click="add">添加</el-button>
            <el-button class="filter-item" style="margin-left: 10px" type="warning" @click="reset">重置</el-button>
          </div>
        </div>

        <el-table border v-loading="listLoading" :data="formData" style="width: 100%" min-height="200" max-height="1000">
          <el-table-column prop="created_at" label="发布时间 " width="250" />
          <el-table-column prop="game_name" label="游戏名称" width="150" />
          <el-table-column prop="is_multiple" label="礼包码类型" width="150" />
          <el-table-column prop="code_type" label="礼包类型" width="150" />
          <el-table-column prop="admin_name" label="发布人" width="150" />
          <el-table-column prop="code_number" width="150" label="剩余数量" />
          <el-table-column label="操作" fixed="right">
            <template slot-scope="scope">
              <el-button size="mini" type="success" @click.native="giftContent(scope.row)">礼包内容查看</el-button>
              <el-button size="mini" type="warning" @click.native="receiveGiftBag(scope.row)">领取礼包</el-button>
              <el-button size="mini" type="primary" @click.native="receivedQuantity(scope.row)">领取数量统计</el-button>
              <el-button size="mini" type="danger" icon="el-icon-delete" @click.native="remove(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <pagination v-show="total > 0" :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.limit" @pagination="getGiftList" />

        <el-dialog title="添加" width="60%" center :visible.sync="addshow" :close-on-click-modal="false" @close="closeDialog">
          <el-form style="margin-left: 40px">
            <el-form-item label="游戏名称" :label-width="formInputWidth">
              <el-col :span="8">
                <el-select v-model="addgameName" filterable placeholder="请选择" style="margin-right: 20px">
                  <el-option v-for="item in gameNameOptions" :key="item.index" :label="item.name" :value="item.id"> </el-option>
                </el-select>
              </el-col>
            </el-form-item>
            <el-form-item label="礼包类型" :label-width="formInputWidth" style="margin-top: 40px">
              <el-col :span="8">
                <el-input v-model="addCode_type" placeholder=""></el-input>
              </el-col>
            </el-form-item>
            <el-form-item label="礼包码类型" :label-width="formInputWidth" style="margin-top: 40px">
              <el-col :span="8">
                <el-select v-model="addgiftType" placeholder="请选择" filterable style="margin-right: 20px">
                  <el-option v-for="item in giftTypeOptions" :key="item.index" :label="item.name" :value="item.id"> </el-option>
                </el-select>
              </el-col>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="removeAdd">取 消</el-button>
            <el-button type="primary" @click="sureAdd">确认</el-button>
          </div>
        </el-dialog>

        <el-dialog title="删除" width="40%" :visible.sync="deleteShow">
          <p style="text-align: center">确认删除礼包信息？</p>
          <div slot="footer" class="dialog-footer">
            <el-button @click="removeDelete">取 消</el-button>
            <el-button type="primary" @click="sureDelete">确认</el-button>
          </div>
        </el-dialog>

        <el-dialog title="领取数量统计" width="40%" :visible.sync="receivedQuantityShow">
          <el-table border v-loading="receiveLoading" :data="collectStatistics" style="width: 100%">
            <el-table-column prop="fetch_admin_name" label="领取人 " />
            <el-table-column prop="fetch_number" label="领取数量" />
          </el-table>
          <div slot="footer" class="dialog-footer">
            <el-button @click="removeReceive">取 消</el-button>
          </div>
        </el-dialog>
      </div>
    </div>
  </div>
</template>


<script>
import { getSelectListApi, getGiftListApi, addGiftTemplateApi, receiveGiftCodeApi, deleteGiftTemplateApi, receiveGiftCodeResultApi } from '@/api/gift_bag.js';
import Clipboard from 'clipboard';
import Pagination from '@/components/pagination/index';
export default {
  components: { Pagination },
  name: 'gift_bag',
  data() {
    return {
      listQuery: {
        game_id: '',
        code_type: '',
        created_at: '',
        page: 1,
        limit: 10,
      },
      gameNameOptions: [],
      giftTypeOptions: [],
      formData: [],
      collectStatistics: [],
      // 添加数据的缓存。
      addCheck: 0,
      keepAddgameName: '',
      keepAddCode_type: '',
      keepAddgiftType: '',

      addgameName: '',
      addCode_type: '',
      addgiftType: '',

      receivedQuantityShow: false,
      addshow: false,
      listLoading: false,
      total: 0,
      formInputWidth: '200px',
      receiveLoading: false,
      deleteShow: false,
      id: '',
      newGiftCode: null,
    };
  },
  created() {
    this.getSelectList();
    this.getGiftList();
  },
  mounted() {
    this.$nextTick(() => {
      this.clipboard = new Clipboard('.getGiftCode');
    });
  },
  methods: {
    add() {
      this.addgameName = '';
      this.addCode_type = '';
      this.addgiftType = '';
      if (this.addCheck == 1) {
        this.addgameName = this.keepAddgameName;
        this.addCode_type = this.keepAddCode_type;
        this.addgiftType = this.keepAddgiftType;
      }
      this.addshow = true;
    },
    closeDialog() {
      if (this.addCheck == 0 || this.addCheck == 1) {
        this.keepAddgameName = this.addgameName;
        this.keepAddCode_type = this.addCode_type;
        this.keepAddgiftType = this.addgiftType;
        this.addCheck = 1;
      }
      if (this.addCheck == 2) {
        this.addCheck = 0;
      }
    },
    removeAdd() {
      this.addshow = false;
    },
    sureAdd() {
      let data = {
        game_id: '',
        code_type: '',
        is_multiple: '',
      };
      data.game_id = this.addgameName;
      data.code_type = this.addCode_type;
      data.is_multiple = this.addgiftType;
      addGiftTemplateApi(data)
        .then((response) => {
          this.addCheck = 2;
          this.addshow = false;
          if (response.data.code === 200) {
            this.$message.success(response.data.message);
            this.getGiftList();
          } else if (response.data.code !== 200) {
            this.$message.error(response.data.message);
          }
        })
        .catch((error) => {
          this.addshow = false;
        });
    },
    search() {
      this.listQuery.page = 1;
      this.getGiftList();
    },
    reset() {
      this.listQuery.game_id = '';
      this.listQuery.code_type = '';
      this.listQuery.created_at = '';
      this.listQuery.page = 1;
      this.listQuery.limit = 10;
      this.getGiftList();
    },
    giftContent(item) {
      let data = {
        id: '',
      };
      data.id = item.id;
      data = JSON.stringify(data);
      this.$router.push({ path: '/customer-gift_content_view', query: { data } });
    },
    receiveGiftBag(item) {
      let data = {
        id: '',
      };
      data.id = item.id;
      receiveGiftCodeApi(data)
        .then((response) => {
          if (response.data.code === 200) {
            this.newGiftCode = response.data.data.comfort_code;
            setTimeout(() => {
              this.$message.success('请点击复制按钮');
              this.getGiftList();
            });
          } else {
            this.$message.error(response.data.message);
          }
        })
        .catch((error) => {});
    },
    remove(item) {
      this.id = item.id;
      this.deleteShow = true;
    },
    removeDelete() {
      this.deleteShow = false;
    },
    sureDelete() {
      let data = {
        id: '',
      };
      data.id = this.id;
      deleteGiftTemplateApi(data)
        .then((response) => {
          if (response.data.code == 200) {
            this.deleteShow = false;
            this.$message.success(response.data.message);
            this.getGiftList();
          } else {
            this.$message.error(response.data.message);
          }
        })
        .catch((error) => {});
    },

    receivedQuantity(item) {
      let data = {
        id: '',
      };
      data.id = item.id;
      receiveGiftCodeResultApi(data)
        .then((response) => {
          this.receivedQuantityShow = true;
          this.collectStatistics = response.data.data;
        })
        .catch((error) => {
          this.receivedQuantityShow = true;
        });
    },

    removeReceive() {
      this.receivedQuantityShow = false;
    },

    getSelectList() {
      getSelectListApi()
        .then((response) => {
          this.gameNameOptions = response.data.data.game;
          this.giftTypeOptions = response.data.data.type;
        })
        .catch((error) => {});
    },

    getGiftList() {
      this.listLoading = true;
      getGiftListApi(this.listQuery)
        .then((response) => {
          this.formData = [];
          this.total = response.data.data.total;
          console.log(response);
          for (let item of response.data.data.data) {
            if (item.is_multiple == 0) {
              item.is_multiple = '普通礼包码';
            } else if (item.is_multiple == 1) {
              item.is_multiple = '通用礼包码';
              if (item.code_number == 0) {
                item.code_number = '未添加通用礼包码';
              } else if (item.code_number == 1) {
                item.code_number = '-';
              }
            }
            this.formData.push(item);
          }
          this.listLoading = false;
        })
        .catch((error) => {
          this.listLoading = false;
        });
    },
    judgeCopy() {
      if (this.newGiftCode == null) {
        this.$message.error('请先获取礼包码再进行复制');
      } else {
        this.$message.success('你已成功复制礼包码');
      }
    },
  },
};
</script>


<style scoped>
.error-page {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 100%;
  height: 100%;
  background: #f3f3f3;
  box-sizing: border-box;
}
.error-code {
  line-height: 1;
  font-size: 250px;
  font-weight: bolder;
  color: #f02d2d;
}
.error-code span {
  color: #00a854;
}
.error-desc {
  font-size: 30px;
  color: #777;
}
.error-handle {
  margin-top: 30px;
  padding-bottom: 200px;
}
.error-btn {
  margin-left: 100px;
}
</style>
